export enum NodeType {
    Question = "PREGUNTA",
    Response = "RESPUESTA",
    Tramite = "TRAMITE",
    Enlace = "ENLACE",
    Form = "FORMULARIO",
    Chat = "CHAT",
    Action = "ACCION",
    FAQ = "FAQ"

}